import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

export default function Redirect_goallist() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/goals'); 
  }, [navigate]); 

  return null; 
}
